<template>
  <FlotoAnchorLink :aria-label="$t('unmark_as_spam')" @click="triggerAction">
    <MIcon name="undo" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $t('unmark_as_spam') }}
    </span>
    <FlotoConfirmModal
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="undo" class="w-full text-primary" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_unmark_as_spam', {
            resource: $tc(moduleName),
          })
        }}
      </template>
    </FlotoConfirmModal>
  </FlotoAnchorLink>
</template>

<script>
export default {
  name: 'UnmarkAsSpam',
  props: {
    moduleName: { type: String, required: true },
    handleUnSpamRequests: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
    }
  },
  methods: {
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleUnSpamRequests) {
        this.processing = true
        this.handleUnSpamRequests()
          .then(() => {
            this.showModal = false
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
  },
}
</script>
